import React, { Component } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import ExamSection from '../components/exams/ExamSection'
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import ScrollTopNavbar from '../components/navbars/ScrollTopNavbar'

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

// Inline shimmer skeleton mirroring the exams card grid.
const ExamShimmer = () => (
    <div className="py-4">
        <div className="rz-shimmer rz-skel-title" style={{ width: '30%', height: '24px' }}></div>
        <Row className="mt-3">
            {Array.from({ length: 6 }).map((_, i) => (
                <Col xl={4} lg={4} md={6} sm={12} key={i} className="mb-4">
                    <Card className="rz-skel-card border-0">
                        <div className="d-flex justify-content-between mb-3">
                            <div className="rz-shimmer rz-skel-line lg" style={{ width: '55%' }}></div>
                            <div className="rz-shimmer rz-skel-line sm" style={{ width: '18%' }}></div>
                        </div>
                        <div className="rz-shimmer rz-skel-line sm" style={{ width: '90%' }}></div>
                        <div className="rz-shimmer rz-skel-line sm" style={{ width: '75%' }}></div>
                        <div className="rz-shimmer rz-skel-btn mt-3" style={{ width: '40%' }}></div>
                    </Card>
                </Col>
            ))}
        </Row>
    </div>
);

const FETCH_ISSTUDENTUSERVALID = gql` 
query($student_user_exam_id: Int!) {
    isStudentUserValid(student_user_exam_id: $student_user_exam_id){
        estatus
        current_plan_id
        expiry_date
        
        user_access_restictions
        module_restrictions
        chapter_ids
        previous_sets
     }
}

`;

const UPDATE_STUDENT_ANALYTICS = gql`
  mutation(
    $params:AnalyticsStudents1  
    ) {
        studentAnalytics(
        params: $params
     )
  }
`;
class Exam extends Component {
    constructor(props) {
        super(props)

        this.state = {
            headerBottomImg: {
                Img: require('../../images/exam.svg'),
                Title: "Create Exams",
                width: 280,
                helpImg: require('../../images/Ask_me_for_Help.gif')
            },
            toggled: isMobile == true && Cookies.get("institution_id") == 30 ? "wrapper" : Cookies.get("toggle"),
             submitError:""
        }
    }
    componentDidMount = () => {

        this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].Exams;
        ReactGA.pageview('/student/exams',["rizee"], title);
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 41,
            source :2

        }
        //console.log("addStudentObj",addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    menuToggler = () => {
        const toggled = this.state.toggled;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        const isStudentUserValid = this.props.isStudentUserValid;
        const loading1 = isStudentUserValid.loading;
        const error1 = isStudentUserValid.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        //console.log("getUserExplored", isStudentUserValid.isStudentUserValid);
        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }
            localStorage.removeItem('isStudentUserValid');
            localStorage.setItem(
                "isStudentUserValid",
                JSON.stringify(isStudentUserValid.isStudentUserValid)
            );
        }

        return (
            <div className={this.state.toggled}>
                <div className="student main-wrapper">
                    <div className="student header-area exam-topnavbar">
                        <ScrollTopNavbar headerBottom={this.state.headerBottomImg} onClick={() => this.menuToggler()} />
                    </div>
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">
                        <Container>
                            {(loading1 == true) && (<ExamShimmer />)}
                            {
                                !loading1 && (
                                    <ExamSection
                                        isStudentUserValid={isStudentUserValid.isStudentUserValid} />
                                )}

                        </Container>
                    </div>

                </div>
            </div>
        )
    }
}


export default withRouter(compose(
    graphql(FETCH_ISSTUDENTUSERVALID,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                // Shared cache entry; revalidated on navigation by utils/sessionValidity.
                fetchPolicy: 'cache-first'
            }), name: "isStudentUserValid"
        }),
        graphql(UPDATE_STUDENT_ANALYTICS, {
            name: "submitpt"
        }),
)(Exam));
